<template>
   <Breadcrumb :home="b2b === 'true' ? homeB2b : homeB2c" :model="context">
    <template #item="{ item, props }">
      <router-link v-if="item.route !== undefined && item.route.indexOf('https://') === -1" v-slot="{ href, navigate }" :to="item.route" custom>
        <a :href="href" v-bind="props.action" @click="navigate">
          <span :class="[item.icon, 'text-color']" />
          <span class="text-primary font-semibold">{{ item.label }}</span>
        </a>
      </router-link>
      <a v-else :href="item.route" :target="item.target" v-bind="props.action">
        <span class="text-surface-700 dark:text-surface-0">{{ item.label }}</span>
      </a>
    </template>
  </Breadcrumb>
</template>

<script>
import { ref } from 'vue'
export default {
  props: {
    context: {
      type: Array,
      default: () => []
    },
    b2b:String
  },
  setup() {
    // this.api.getCookies('page')
    const homeB2c = ref({
      icon: 'pi pi-home',
      route: '/'
    })
    const homeB2b = ref({
      icon: 'pi pi-home',
      route: '/biz'
    })
    return {
      homeB2c, homeB2b
    }
  }
}
</script>
